module.exports = __webpack_public_path__ + "img/profile.0d23ed45.png";